import * as React                      from 'react';
import * as PropTypes                  from 'prop-types';
import * as cx                         from 'classnames';
import Alert                           from '../../components/Alert';
import { MessagesInputContainerProps } from './MessagesInputTypes';
import { ViewContextTypes }            from '../MessageTemplatesList/MessageTemplatesListTypes';
import MessageTemplatesList            from '../MessageTemplatesList';
import DefaultInput                    from './DefaultInput';
import InputViewToggle                 from './InputViewToggle';
import { MessageDeliveryStatuses }     from '../../types';
import { isMobileChrome }              from '../../helpers/messenger';

const MessagesInput: React.StatelessComponent<MessagesInputContainerProps> = ({ activeLanguage, handleSendMessage, waitingForReplyStatus, characterLimit, value, handleChange, handleKeyDown, history, isOnCallList, inputView, handleChangeInputView, conversationId, recipient, onDesktop, itemsPerPage, templatesInitialized, initializeTemplates, setInputView, lastMessageStatus, profanityMessage, setDefault }, { translate }) => {
    return (
        <div
            className={cx('footer', {footer__isActive: true})}
            onClick={this.showWaitingForReplyError}
        >
            {
                history.location.state && history.location.state.alert &&
                <Alert
                    message={history.location.state.alert.message}
                    type={history.location.state.alert.type}
                    delay={5000}
                />
            }
            {
                waitingForReplyStatus &&
                <Alert message={translate('wait_for_reply_warning')} />
            }
            <div
                className={cx('footer__inputContainer', {'messageFeedInput--raised': isMobileChrome() })}
                onClick={this.focusInput}>
                {
                    !waitingForReplyStatus && lastMessageStatus !== MessageDeliveryStatuses.ERROR &&
                    <InputViewToggle
                        inputView={inputView}
                        handleChangeInputView={handleChangeInputView}
                    />
                }
                {
                    inputView !== ViewContextTypes.MESSAGES_INPUT &&
                    <DefaultInput
                        handleChange={handleChange}
                        handleKeyDown={handleKeyDown}
                        waitingForReplyStatus={waitingForReplyStatus}
                        value={value}
                        characterLimit={characterLimit}
                        handleSendMessage={handleSendMessage}
                        inputView={inputView}
                        lastMessageStatus={lastMessageStatus}
                        profanityMessage={profanityMessage}
                        setDefault={setDefault}
                        recipient={recipient}
                    />
                }
            </div>
            {
                inputView === ViewContextTypes.MESSAGES_INPUT && !waitingForReplyStatus &&
                <MessageTemplatesList
                    activeLanguage={activeLanguage}
                    conversationId={conversationId}
                    recipient={recipient}
                    onDesktop={onDesktop}
                    itemsPerPage={itemsPerPage}
                    viewContext={inputView}
                    templatesInitialized={templatesInitialized}
                    initializeTemplates={initializeTemplates}
                    setInputView={setInputView}
                />
            }
        </div>
    );
};

export default MessagesInput;

MessagesInput.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/MessagesInput/MessagesInput.tsx